/**
 * The two sentences the buttons send on the user's behalf, in each language
 * of the interface.
 *
 * Not in the i18n bundle: they are read by the model, not shown, so a
 * translator reweighting them would be rewriting an instruction. What the user
 * sees of them is the "Skipped" badge and the search that follows.
 *
 * They are sent in the interface's language — the one the API declares to the
 * model as the user's (`Accept-Language`) — because the model answers in the
 * language of the last user message: a French user who skipped a question got
 * the search, the summary and the quick replies in English.
 */
const BUTTON_MESSAGES = {
  skipQuestion: {
    fr: "Peu importe, passe à la question suivante.",
    en: "Doesn't matter, move on to the next question.",
  },
  searchNow: {
    fr: "Lance la recherche avec ce que tu as.",
    en: "Run the search with what you have.",
  },
} as const;

/**
 * The sentence a skip button sends, in the interface's language — French
 * unless the interface is in English, as the API reads `Accept-Language`.
 */
export function getClarificationButtonMessage(
  button: keyof typeof BUTTON_MESSAGES,
  language: string | undefined,
): string {
  return BUTTON_MESSAGES[button][language?.startsWith("en") ? "en" : "fr"];
}
